module.exports = __webpack_public_path__ + "img/spiral.35657e5a.webp";